export const MAX_INPUT = {
    SMS: 320,
    TEXT: 255,
}
